<!-- eslint-disable vue/multi-word-component-names -->
<template>
	<div class="layouts_header_content" style="justify-content: space-between;">
		<div class="layouts_header_left">
			<div class="breadcrumbs_box">
				<div class="breadcrumbs_list" v-for="(item, index) in breadcrumbs" :key="index">
					<template v-if="(index + 1) == breadcrumbs.length">
						<span>{{ getRoutesName(item.path) }}</span>
					</template>
					<template v-else-if="getRoutesName(item.path)">
						<span class="breadcrumbs" @click="onGoRouter(item)">{{ getRoutesName(item.path) }}</span>
						<right-outlined :show-opacity="false" class="icon" />
					</template>
				</div>
				<div class="customer_name" v-if="externalOrderPaths.includes(pathname) && route.query.source != 1">
					<span class="a_link" style="font-weight: bold;">{{ `（客户名称：${orderRecord.customerName}）` }}</span>
				</div>
			</div>
		</div>
		<div class="layouts_header_right">
			<div class="msg_box" style="cursor: pointer;" @click="onGoToBeDone">
				<a-badge :count="store.getters.userInfoData?.waitAuditCount || 0">
					<BellOutlined />
				</a-badge>
			</div>
			<div class="select_color_box">
				<a-popover>
					<template #content>
						<div class="select_color_content">
							<color-picker default-color="#ff2442" v-model:hex="color" @change="onChangeColor" />
						</div>
					</template>
					<img src="@/assets/image/layouts/color_img.png" alt="" class="color_img">
				</a-popover>
			</div>
			<template v-if="externalOrderPaths.includes(pathname) && route.query.source != 1">
				<div class="user_info" @click="onClickLogo">
					<div class="user_image">
						<img src="@/assets/image/layouts/user_img.png" alt="头像" class="image">
					</div>
					<div class="user_name">
						<!-- <span>{{ store.getters.userInfoData?.username }}</span> -->
						<span>返回系统</span>
					</div>
				</div>
			</template>
			<template v-else>
				<a-popover overlayClassName="layouts_header_popover" placement="bottomRight">
					<template #content>
						<a-button danger class="danger_button" @click="onSwitch"
							v-if="userInfo.companyIdentUsers?.length > 1">切换主体</a-button>
						<a-button danger class="danger_button footer_button" @click="onOutLogin">退出登录</a-button>
					</template>
					<div class="user_info">
						<div class="user_image">
							<img src="@/assets/image/layouts/user_img.png" alt="头像" class="image">
						</div>
						<div class="user_name">
							<span>{{ store.getters.userInfoData?.username }}</span>
						</div>
					</div>
				</a-popover>
			</template>
		</div>
		<SelectCompany ref="selectCompanyRef" />
	</div>
</template>
<script>
import {
	useStore
} from "vuex";
import {
	computed,
	onMounted,
	ref
} from 'vue';
import {
	useRoute,
	useRouter
} from 'vue-router';
import {
	RightOutlined,
	BellOutlined
} from '@ant-design/icons-vue';
import {
	rgbaTo16color
} from '@/utils/index';
import {
	fourBreadcrumbsList
} from './constance';
import { externalOrderPaths } from './constance';
import ColorPicker from 'colorpicker-v3';
import SelectCompany from '@/views/login/selectCompany.vue';

export default {
	components: {
		ColorPicker,
		RightOutlined,
		BellOutlined,
		SelectCompany
	},
	setup() {
		const store = useStore();
		const router = useRouter();
		const route = useRoute();
		const color = ref('#ff2442');
		const orderRecord = ref({});
		const userInfo = ref({});
		const pathname = ref(location.pathname);
		const selectCompanyRef = ref(null);
		// const allRoutes = router.options.routes;

		const breadcrumbs = computed(() => {
			const pathSnippets = route.path.split('/').filter(Boolean);
			const breadcrumbs = [];
			for (let i = 0; i < pathSnippets.length; i++) {
				const fourList = fourBreadcrumbsList[pathSnippets[i]];
				if (fourList) {
					fourList.map(item => {
						const url = `/${pathSnippets.slice(0, i).join('/')}${item}`;
						const breadcrumb = pathSnippets[i];
						breadcrumbs.push({
							path: url,
							meta: {
								breadcrumb
							}
						});
					});
				} else {
					const url = `/${pathSnippets.slice(0, i + 1).join('/')}`;
					const breadcrumb = pathSnippets[i];
					breadcrumbs.push({
						path: url,
						meta: {
							breadcrumb
						}
					});
				}
			}
			return breadcrumbs;
		});

		const getRoutesName = (path) => {
			let routeName = '',
				menuDataList = [],
				jsonStrVal = localStorage.getItem('router_data_list');
			if (jsonStrVal) menuDataList = JSON.parse(jsonStrVal);
			if (path == '/redMan/saleRebate/addSaleRebate') {
				const rebateType = route.query.rebateType;
				if (rebateType == 1) routeName = '新增返点合同';
				else routeName = '新增返点打款';
			} else if (path == '/redMan/saleRebate/saleRebateDetails') {
				const rebateType = route.query.rebateType;
				if (rebateType == 1) routeName = '返点合同详情';
				else routeName = '返点打款详情';
			} else if (path == '/financialManage/addClientRefund') {
				const refundType = route.query.refundType;
				if (refundType == 1) routeName = '申请回款';
				else if (refundType == 2) routeName = '申请退款';
				else routeName = '申请划转';
			} else if (path == '/financialManage/clientRefundDetails') {
				const refundType = route.query.refundType;
				if (refundType == 1) routeName = '回款详情';
				else if (refundType == 2) routeName = '退款详情';
				else routeName = '划转详情';
			} else menuDataList.map(item => {
				if (item.path == path) routeName = item.meta.title;
				item?.children?.map(ite => {
					if (ite.path == path) routeName = ite.meta.title;
					ite?.children?.map(it => {
						if (it.path == path) routeName = it.meta.title;
					});
				});
			});
			return routeName;
		};

		/**
		 * @function 切换
		 * @param
		 */
		const onSwitch = () => {
			selectCompanyRef.value.init(userInfo.value);
		};

		/**
		 * @function 退出登录
		 * @param
		 */
		const onOutLogin = () => {
			localStorage.removeItem('token');
			localStorage.removeItem('user_info');
			router.push('/login');
		};

		/**
		 * @function 跳转
		 * @param item 
		 */
		const onGoRouter = (item) => {
			const noGoPath = ['/basicFile', '/throwInManage', '/throwInManage/innerOrder',
				'/throwInManage/offlinePayment'
			];
			if (!noGoPath.includes(item.path)) router.push(item.path);
		};

		/**
		 * @function 设置颜色
		 * @param val 
		 */
		const onChangeColor = (val) => {
			const getRgbaValue = (n) => {
				let value = '';
				const cv_1 = val.rgba.split(',');
				cv_1.map((item, index) => {
					if (index + 1 < cv_1.length) value += `${item},`;
				});
				return rgbaTo16color(`${value}${n})`);
			};
			const c_1 = val.hex;
			const c_2 = getRgbaValue('.8');
			const c_3 = getRgbaValue('.7');
			const c_4 = getRgbaValue('.1');
			const c_5 = getRgbaValue('.2');
			const c_6 = getRgbaValue('.4');

			document.getElementsByTagName('body')[0].style.setProperty('--primary-color', c_1);
			document.getElementsByTagName('body')[0].style.setProperty('--hover-bg-color', c_2);
			document.getElementsByTagName('body')[0].style.setProperty('--hover-font-color', c_3);
			document.getElementsByTagName('body')[0].style.setProperty('--bg-color-1', c_4);
			document.getElementsByTagName('body')[0].style.setProperty('--bg-color-2', c_5);
			document.getElementsByTagName('body')[0].style.setProperty('--bg-color-4', c_6);
			localStorage.setItem('chu_xin_theme', JSON.stringify({
				c_1,
				c_2,
				c_3,
				c_4,
				c_5,
				c_6
			}));
		};

		const onClickLogo = () => {
			const identity = localStorage.getItem('user_login_identity');
			if (identity == 'cx' && location.pathname != '/toBeDone') window.open('/toBeDone');
			else window.open('/business/cstomer');
		};

		const onGoToBeDone = () => {
			router.push('/toBeDone');
		};

		onMounted(() => {
			if (sessionStorage.getItem('outer_order_record')) orderRecord.value = JSON.parse(sessionStorage.getItem('outer_order_record'))
			if (localStorage.getItem('user_info')) userInfo.value = JSON.parse(localStorage.getItem('user_info'));
		});

		return {
			store,
			color,
			route,
			breadcrumbs,
			orderRecord,
			pathname,
			userInfo,
			externalOrderPaths,
			selectCompanyRef,
			onClickLogo,
			onSwitch,
			onOutLogin,
			getRoutesName,
			onGoRouter,
			onChangeColor,
			onGoToBeDone
		};
	}
}
</script>
<style lang="scss">
@use '@/_variables';
// @use '@/assets/css/style.css';

.layouts_header_content {
	width: 100%;
	height: 56px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding: 0 24px;

	.user_info {
		height: 32px;
		padding: 0 8px;
		border-radius: 34px 34px 34px 34px;
		border: 1px solid #F0F0F0;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;

		.user_image {
			.image {
				width: 24px;
				height: 24px;
			}
		}

		.user_name {
			font-weight: 400;
			font-size: 14px;
			margin-left: 8px;
		}
	}

	.layouts_header_left {

		.breadcrumbs_box {
			display: flex;
			align-items: center;
			justify-content: flex-start;

			.customer_name {
				color: #666;
				font-size: 14px;
			}
		}

		.breadcrumbs_list {
			height: 22px;
			font-size: 14px;
			color: #666;
			display: flex;
			align-items: center;
			justify-content: flex-start;

			.icon {
				font-size: 12px;
				margin: 0 4px;
			}

			.breadcrumbs {
				cursor: pointer;
			}

			.breadcrumbs:hover {
				color: variables.$hover-font-color;
			}
		}
	}

	.layouts_header_right {
		display: flex;
		align-items: center;
		justify-content: flex-end;

		.msg_box {
			margin-right: 30px;

			.anticon {
				font-size: 16px;
			}

			.ant-scroll-number {
				top: -2px;
				right: -6px;
				height: 16px;
				line-height: 16px;
			}
		}

		.select_color_box {
			margin-right: 12px;

			.color_img {
				width: 30px;
				height: 30px;
				cursor: pointer;
			}
		}
	}
}

.layouts_header_popover {
	width: 176px;
	top: 40px !important;

	.ant-popover-arrow {
		display: none;
	}

	.danger_button {
		width: 100%;
		margin-bottom: 12px;
		color: #333 !important;
		border-color: #d9d9d9 !important;
	}

	.danger_button:hover {
		color: variables.$primary-color !important;
		border-color: variables.$primary-color !important;
	}

	.footer_button {
		margin-bottom: 0;
	}
}
</style>